import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSignaturePadComponent } from './ng-signaturepad.component';

@NgModule({
  declarations: [NgSignaturePadComponent],
  imports: [CommonModule],
  exports: [NgSignaturePadComponent],
})
export class NgSignaturePadModule {}
